import { setTerms } from './helpers';

export const setGarageTypes = setTerms('garage_type');
